import addMount from "../../core/addMount";
import AdvancedSearchV2 from "./AdvancedSearchV2.entry";

addMount({ appName: "advanced-search-v2", app: AdvancedSearchV2 });
